import React from "react";

import "./contact.css";

const Contact = () => {
  return (
    <div className="contact container">
      <h2>Contact Me</h2>

      <div className="row">
        <div className="col s3">Github</div>
        <div className="col s9">
          <a href="http://github.com/aa1aac" target="new" className="links">
            @aa1aac <i className="fa fa-github"></i>
          </a>
        </div>
        <div className="col s3">Email</div>
        <div className="col s9">
          <a className="links" href="mailto:ach.aayush.111@gmail.com">
            ach.aayush.111@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
